import { LIST_IMPORT } from 'constants/actionTypes';
import {
  AUDIENCE_LISTS,
  AUDIENCE_LISTS_ADD,
  AUDIENCE_LISTS_DETAILS,
  AUDIENCE_LISTS_NON_PROFILED_CONTACTS,
  AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE,
  AUDIENCE_LISTS_PROFILED_CONTACTS,
  AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE,
  AUDIENCE_LISTS_SEARCH,
  AUDIENCE_LISTS_DELETE,
  AUDIENCE_LISTS_NAME_EDIT,
  AUDIENCE_LISTS_CONTACTS_EDIT,
  AUDIENCE_LISTS_BOTH,
} from 'constants/types';
import * as Interfaces from '../interface';

const audienceListsInitialState: Interfaces.IAudienceListState = {
  data: Array<Interfaces.IListItem>(),
  totalLists: 0,
  totalSearchedLists: 0,
  paginationStatus: true,
  exportLoading: false,
  showExportPopup: false,
  showExportPopupError: false,
  exportEmail: '',
  loading: false,
  listAlreadyExists: false,
  page: 0,
  addList: {
    loading: false,
    success: false,
    fail: false,
  },
  removeList: {
    loading: false,
    success: false,
    fail: false,
  },
  editListName: {
    loading: false,
    success: false,
    fail: false,
  },
  searchData: Array<Interfaces.IListItem>(),
  searchedLoading: false,
  searchedPage: 0,
  searchTerm: '',
  resetSearchCount: 0,
  list_import: false,
  message: '',
  success: true,
  removeSearch: false,
  check: false,
  importedListContactsCount: 0,
  listsDataNamesLoading: false,
  listsDataNames: Array<Interfaces.IListDataNames>(),
  cloneLoading: false,
  cloneListFailedCheck: false,
  listAudienceFilters: {} as Interfaces.IListAudienceFilters,
  newListCreated: false,
  showDetailsTabAddContactSuccessMessage: false, // to show success message on add contact to list from contact details tab
};

export const audienceListsReducer = (state = audienceListsInitialState, action: Interfaces.IAudienceListAction) => {
  const newState = { ...state };
  const { payload } = action;
  const defaultState = { ...audienceListsInitialState };
  switch (action.type) {
    //Export
    case AUDIENCE_LISTS.ENABLE_EXPORT_LOADER:
      newState.exportLoading = true;
      return newState;
    case AUDIENCE_LISTS.DISABLE_EXPORT_LOADER:
      newState.exportLoading = false;
      return newState;
    case AUDIENCE_LISTS.SET_OPEN:
      newState.showExportPopup = true;
      newState.showExportPopupError = false;
      newState.exportLoading = false;
      if (action.payload) newState.exportEmail = action.exportEmail;
      return newState;
    case AUDIENCE_LISTS.SET_ERROR:
      newState.showExportPopupError = true;
      newState.exportLoading = false;
      return newState;
    case AUDIENCE_LISTS.SET_CLOSE:
      newState.showExportPopupError = false;
      newState.showExportPopup = false;
      newState.exportLoading = false;
      return newState;
    case AUDIENCE_LISTS.FILTERS:
      newState.listAudienceFilters = action.filters;
      return newState;

    //Listing

    case AUDIENCE_LISTS.LOAD:
      newState.loading = true;
      return newState;

    case AUDIENCE_LISTS.SUCCESS:
      newState.loading = false;
      // newState.success = true;
      newState.page = state.page + 1;
      if (action.payload) {
        if (action?.payload?.import) {
          newState.totalLists = newState.totalLists + 1;
          newState.data = [...action?.payload?.lists];
        } else {
          newState.totalLists = action.payload?.totalLists;
          newState.data = [...newState.data, ...action?.payload?.lists];
        }
      }
      if (newState.page > 1 && payload?.lists.length === 0) {
        newState.paginationStatus = false;
      }
      if ((payload?.lists.length ?? 2) < 8) {
        newState.paginationStatus = false;
      }
      return newState;

    case AUDIENCE_LISTS.FAIL:
      newState.loading = false;
      if (action?.payload?.message === 'List with that name already exists') {
        newState.listAlreadyExists = !newState.listAlreadyExists;
      }
      return newState;

    case AUDIENCE_LISTS.RESET_ALREADY_EXIST_ERROR:
      newState.listAlreadyExists = false;
      return newState;

    case AUDIENCE_LISTS.RESET:
      newState.paginationStatus = false;
      newState.data = [];
      newState.page = 0;
      newState.loading = false;
      return newState;

    case AUDIENCE_LISTS.UPDATE_CONTACTS_COUNT:
      if (action?.updateContactCount) {
        let newData = state.data.map((item: any) => {
          if (
            item?.id?.toString() === action?.updateContactCount?.listId?.toString() &&
            action.updateContactCount.updateCount
          ) {
            let newItem = { ...item };
            if (action.updateContactCount?.deleteAllFlag) {
              newItem.totalContacts = item.totalContacts - action.updateContactCount?.countToDelete;
            } else {
              if (action.updateContactCount.add) {
                newItem.totalContacts = item.totalContacts + action.updateContactCount.updateCount;
              } else {
                newItem.totalContacts = item.totalContacts - action.updateContactCount.updateCount;
              }
            }
            newItem.lastUpdated = 'just now';
            return newItem;
          }
          return item;
        });
        newState.data = newData;
      }
      return newState;

    case AUDIENCE_LISTS.REMOVE_FROM_LIST:
      if (action?.isSearched) {
        const searchedIndex = newState.searchData.findIndex((listObj) => listObj.id === parseInt(action?.listId!, 10));
        const updatedListSearch = [...newState.searchData];
        updatedListSearch.splice(searchedIndex, 1);
        newState.searchData = updatedListSearch;
        newState.totalSearchedLists -= 1;
      }
      const index = newState.data.findIndex((listObj) => listObj.id === parseInt(action?.listId!, 10));
      const updatedList = [...newState.data];
      updatedList.splice(index, 1);
      newState.data = updatedList;
      newState.totalLists -= 1;
      return newState;

    case AUDIENCE_LISTS_ADD.RESET_REMOVE_SEARCH:
      newState.removeSearch = false;
      return newState;

    // when contact is added to list from contact/person details tab
    case AUDIENCE_LISTS_ADD.DETAILS_SUCCESS_MESSAGE:
      newState.showDetailsTabAddContactSuccessMessage = action.flag;
      return newState;

    case AUDIENCE_LISTS_ADD.SUCCESS:
      newState.addList.loading = false;
      newState.addList.success = true;
      const list = [...newState.data];
      if (action.listItem && action?.fromSimilar) {
        if (list.length > 0) {
          newState.data = [action.listItem, ...list];
          newState.page = state.page + 1;
        } else newState.page = 0;
      } else if (action.listItem) {
        newState.data = [action.listItem, ...list];
        newState.page = state.page + 1;
      }
      newState.removeSearch = true;
      newState.totalLists += 1;
      return newState;

    case AUDIENCE_LISTS_ADD.FAIL:
      newState.addList.loading = false;
      newState.addList.fail = true;
      newState.message = action.message ?? '';
      return newState;

    case AUDIENCE_LISTS_ADD.RESET:
      newState.addList = { loading: false, fail: false, success: false };
      newState.message = '';
      return newState;

    case AUDIENCE_LISTS_ADD.NEWLY_CREATED_LIST_CHECK:
      newState.newListCreated = action?.newListCreated ? action?.newListCreated : false;
      return newState;

    case AUDIENCE_LISTS_DELETE.LOAD:
      newState.removeList.loading = true;
      return newState;

    case AUDIENCE_LISTS_DELETE.SUCCESS:
      newState.loading = false;
      newState.removeList.loading = false;
      newState.removeList.success = true;
      return newState;

    case AUDIENCE_LISTS_DELETE.FAIL:
      newState.removeList.loading = false;
      newState.removeList.fail = true;
      return newState;

    case AUDIENCE_LISTS_DELETE.RESET:
      newState.removeList = { loading: false, success: false, fail: false };
      return newState;

    case AUDIENCE_LISTS_SEARCH.SET_SEARCH:
      if (action.searchTerm) {
        if (action.searchTerm === newState.searchTerm) {
          newState.check = !newState.check;
        }
        newState.searchTerm = action.searchTerm;
        newState.searchData = [];
        // newState.searchedLoading = false;
        newState.searchedPage = 0;
        newState.totalSearchedLists = 0;
      }

      return newState;

    case AUDIENCE_LISTS_SEARCH.LOAD:
      newState.searchedLoading = true;
      return newState;

    case AUDIENCE_LISTS_SEARCH.SUCCESS:
      newState.searchedLoading = false;
      if (newState.loading) newState.loading = false;
      newState.totalSearchedLists = action.payload.totalLists;
      newState.searchedPage = state.searchedPage + 1;
      if (action.payload) {
        newState.searchData = [...state.searchData, ...action?.payload?.lists];
      }
      return newState;

    case AUDIENCE_LISTS_SEARCH.ERROR_SEARCH_TERM:
      newState.success = action.success;
      newState.message = action.message;
      return newState;

    case AUDIENCE_LISTS_SEARCH.ERROR_SEARCH_TERM_LOADING:
      newState.searchedLoading = false;
      return newState;

    case AUDIENCE_LISTS_SEARCH.FAIL:
      newState.searchedLoading = false;
      return newState;

    case AUDIENCE_LISTS_SEARCH.RESET:
      newState.searchData = [];
      newState.searchedLoading = false;
      newState.searchedPage = 0;
      newState.searchTerm = '';
      newState.totalSearchedLists = 0;
      return newState;

    case AUDIENCE_LISTS_NAME_EDIT.LOAD:
      newState.editListName.loading = true;
      return newState;

    case AUDIENCE_LISTS_NAME_EDIT.UPDATE_LAST:
      newState.data = newState.data.map((item) => {
        if (item?.id?.toString() === action?.listId?.toString()) {
          item.lastUpdated = 'just now';
        }
        return item;
      });
      return newState;

    case AUDIENCE_LISTS_NAME_EDIT.SUCCESS:
      newState.editListName.loading = false;
      newState.editListName.success = true;
      newState.data = newState.data.map((item) => {
        if (item.id.toString() === action.listId?.toString()) {
          item.name = action.listName;
          item.lastUpdated = 'just now';
        }
        return item;
      });
      return newState;

    case AUDIENCE_LISTS_NAME_EDIT.FAIL:
      newState.editListName.loading = false;
      newState.editListName.fail = true;
      return newState;

    case AUDIENCE_LISTS_NAME_EDIT.RESET:
      newState.editListName = { loading: false, success: false, fail: false };
      return newState;

    case AUDIENCE_LISTS.CHANGE_SEARCH_COUNT:
      newState.resetSearchCount = state.resetSearchCount + 1;
      return newState;
    case LIST_IMPORT.SUCCESS:
      newState.list_import = true;
      return newState;
    case LIST_IMPORT.CLOSE:
      newState.list_import = false;
      return newState;
    case LIST_IMPORT.PUBLISH_EMAIL_SUCCESS:
      if (action.importedListContactsCount)
        newState.importedListContactsCount = newState.importedListContactsCount + action.importedListContactsCount;
      return newState;

    case AUDIENCE_LISTS.NAMES_LOAD:
      newState.listsDataNamesLoading = true;
      return newState;
    case AUDIENCE_LISTS.NAMES_LOAD_SUCCESS:
      newState.listsDataNamesLoading = false;
      if (action.listsDataNames) newState.listsDataNames = action.listsDataNames;

      return newState;
    case AUDIENCE_LISTS.NAMES_FAIL:
      newState.listsDataNamesLoading = false;
      return newState;

    case AUDIENCE_LISTS.NAMES_RESET:
      newState.listsDataNamesLoading = false;
      newState.listsDataNames = [];
      return newState;

    // Clone
    case AUDIENCE_LISTS.CLONE_LOAD:
      newState.cloneLoading = true;
      return newState;

    case AUDIENCE_LISTS.CLONE_SUCCESS:
      let List = state.data;
      const listId = action.listId ?? 0;

      let indexOfList = List.findIndex((item) => item.id.toString() === listId.toString());

      const thumbnailsOfOriginlaCLonedList = newState.data[indexOfList].topContactsThumbnail;

      let clonedListData = {} as Interfaces.IListItem;
      const resData = action?.payload?.listData;

      clonedListData.is_active = resData.is_active;
      clonedListData.id = resData.list_id;
      clonedListData.name = resData.list_name;
      clonedListData.topContactsThumbnail = thumbnailsOfOriginlaCLonedList;
      clonedListData.totalContacts = resData.total_contacts;
      clonedListData.totalSent = resData.total_sent;
      clonedListData.totalClicks = resData.total_clicks;
      clonedListData.lastUpdated = 'just now';
      clonedListData.isCampaign = resData.is_campaign;
      clonedListData.campaignsCount = resData.campaigns_count;
      clonedListData.createdBy = resData.created_by;
      clonedListData.lastUsedBy = resData.last_used_by;

      newState.data.splice(indexOfList + 1, 0, clonedListData);

      newState.data = [...newState.data];
      newState.cloneLoading = false;
      newState.totalLists = newState.totalLists + 1;
      return newState;

    case AUDIENCE_LISTS.CLONE_FAIL:
      newState.cloneLoading = false;
      newState.cloneListFailedCheck = !newState.cloneListFailedCheck;
      return newState;

    case AUDIENCE_LISTS.CLONE_SUCCESS_SEARCH:
      let ListSearch = state.searchData;
      const listIdSearch = action.listId ?? 0;

      let indexOfListSearch = ListSearch.findIndex((item) => item.id.toString() === listIdSearch.toString());

      const thumbnailsOfOriginlaCLonedListSearch = newState.searchData[indexOfListSearch].topContactsThumbnail;

      let clonedListDataSearch = {} as Interfaces.IListItem;
      const resDataSearch = action?.payload?.listData;

      clonedListDataSearch.is_active = resDataSearch.is_active;
      clonedListDataSearch.id = resDataSearch.list_id;
      clonedListDataSearch.name = resDataSearch.list_name;
      clonedListDataSearch.topContactsThumbnail = thumbnailsOfOriginlaCLonedListSearch;
      clonedListDataSearch.totalContacts = resDataSearch.total_contacts;
      clonedListDataSearch.totalSent = resDataSearch.total_sent;
      clonedListDataSearch.totalClicks = resDataSearch.total_clicks;
      clonedListDataSearch.lastUpdated = 'just now';
      clonedListDataSearch.isCampaign = resDataSearch.is_campaign;
      clonedListDataSearch.campaignsCount = resDataSearch.campaigns_count;

      newState.searchData.splice(indexOfListSearch + 1, 0, clonedListDataSearch);

      newState.searchData = [...newState.searchData];
      newState.cloneLoading = false;
      newState.totalLists = newState.totalLists + 1;
      if (action.isSearched) newState.totalSearchedLists = newState.totalSearchedLists + 1;
      return newState;

    default:
      return newState;
  }
};

const audienceListDetailsInitialState: Interfaces.IAudienceListDetailsState = {
  listId: '',
  message: '',
  success: true,
  loading: false,
  listName: '',
  campaignsAndAssetsCount: 0,
  exportLoading: false,
  selectedFilters: {
    designations: [],
    organizations: [],
    personality: [],
    status: [],
  },
  filters: {
    designations: [],
    organizations: [],
    personality: [],
    status: [],
  },
  profiled: {
    loading: false,
    page: 0,
    // paginationStatus: true,
    data: Array<Interfaces.IContactItem>(),
  },
  nonProfiled: {
    loading: false,
    page: 0,
    // paginationStatus: true,
    data: Array<Interfaces.IContactItem>(),
  },
  delete: {
    loading: false,
    success: false,
    fail: false,
  },
  removeProfiledFromUnprofiled: false,
  removeUnprofiledFromProfiled: false,
  reloadList: false,
  totalContacts: 0,
  searchTermListDetails: '',
  contactUpdated: false,
  contactUpdateError: '',
  contactAddedInList: false,
  newlyCreatedListId: '',
  // for handling browser back button and resetting the state for list details for add contacts by searching
  appliedSearch: false,
  clearSearchTerm: false,
  contactsAddedToList: [],
};

export const audienceListDetailsReducer = (
  state = audienceListDetailsInitialState,
  action: Interfaces.IAudienceListDetailsAction,
) => {
  const newState = { ...state };
  switch (action.type) {
    case AUDIENCE_LISTS_DETAILS.ALREADY_EXISTS:
      newState.message = action.message;
      return newState;

    case AUDIENCE_LISTS_DETAILS.LOAD:
      newState.loading = true;
      return newState;

    case AUDIENCE_LISTS_DETAILS.SUCCESS:
      newState.loading = false;
      if (action.listId) newState.listId = action.listId;
      if (action.listName) newState.listName = action.listName;
      if (action.campaignsAndAssetsCount) newState.campaignsAndAssetsCount = action.campaignsAndAssetsCount;
      return newState;

    case AUDIENCE_LISTS_DETAILS.FAIL:
      newState.loading = false;
      return newState;

    case AUDIENCE_LISTS_DETAILS.RESET:
      newState.loading = false;
      newState.listName = '';
      newState.campaignsAndAssetsCount = 0;
      newState.listId = '';
      return newState;

    case AUDIENCE_LISTS_DETAILS.SET_NAME:
      newState.listName = action.listName;
      return newState;

    case AUDIENCE_LISTS_DETAILS.SET_RELOAD_LIST:
      if (action.isProfiled === 'profiled') newState.profiled.reloadList = action.reloadList;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS.LOAD:
      newState.profiled.loading = true;
      return newState;

    case AUDIENCE_LISTS_DETAILS.ADD_NEW_CONTACT:
      newState.totalContacts += 1;
      newState.contactAddedInList = true;
      if (newState.totalContacts > 0) newState.exportLoading = false;
      else newState.exportLoading = true;
      if (action.selectedTab === 'profiled') {
        let index = newState.profiled.data.findIndex(
          (item) => item.id.toString() === action?.createdContact?.id.toString(),
        );
        if (index >= 0) {
          newState.profiled.data[index] = { ...action?.createdContact };
        } else {
          newState.profiled.data = [action.createdContact, ...state.profiled.data];
          if (action.selectedTab !== 'profiled') newState.removeUnprofiledFromProfiled = true;
        }
      } else {
        let indx = newState.nonProfiled.data.findIndex(
          (item) => item.id.toString() === action?.createdContact?.id.toString(),
        );
        if (indx >= 0) {
          newState.nonProfiled.data[indx] = { ...action.createdContact };
        } else {
          let new_contact = {
            ...action.createdContact,
            personality:
              action.selectedTab === 'profield' && !action?.createdContact?.personality
                ? 'Profiling'
                : action?.createdContact?.personality,
          };

          newState.nonProfiled.data = [new_contact, ...newState.nonProfiled.data];
          if (action.selectedTab === 'profiled') {
            newState.removeProfiledFromUnprofiled = true;
            let index2 = newState.profiled.data.findIndex(
              (item) => item.id.toString() === action?.createdContact?.id.toString(),
            );
            if (index2 >= 0) {
              newState.profiled.data[index2] = { ...action.createdContact };
            } else {
              newState.profiled.data = [action.createdContact, newState.profiled.data];
            }
          }
        }
      }
      return newState;
    case AUDIENCE_LISTS_DETAILS.RESET_NEWLY_ADDED_CONTACT:
      newState.contactAddedInList = false;
      return newState;
    case AUDIENCE_LISTS_DETAILS.CONTACT_UPDATED_SUCCESS:
      newState.contactUpdated = true;
      return newState;
    case AUDIENCE_LISTS_DETAILS.RESET_CONTACT_UPDATED_SUCCESS:
      newState.contactUpdated = false;
      return newState;
    case AUDIENCE_LISTS_DETAILS.CONTACT_FAILED_TO_UPDATE:
      newState.contactUpdateError = action.errorMessage;
      return newState;
    case AUDIENCE_LISTS_DETAILS.RESET_CONTACT_FAILED_TO_UPDATE:
      newState.contactUpdateError = '';
      return newState;
    case AUDIENCE_LISTS_PROFILED_CONTACTS.SUCCESS:
      newState.profiled.loading = false;
      if (action.totalContacts !== undefined) newState.totalContacts = action.totalContacts;
      // newState.totalContacts = action.totalContacts;
      if (newState.totalContacts > 0) {
        newState.exportLoading = false;
      } else {
        newState.exportLoading = true;
      }
      if (action.listId) newState.listId = action.listId;
      if (action?.profiledList && action?.profiledList?.length > 0) {
        if (action?.reset) {
          if (newState.contactsAddedToList.length > 0) {
            const filteredContacts = action.profiledList.filter(
              (contact) =>
                !newState.contactsAddedToList.some(
                  (listContact: { [key: string]: any }) => contact.id === listContact.id,
                ),
            );
            // After user has added contacts to list.
            newState.profiled.data = [...newState.contactsAddedToList, ...filteredContacts];
          } else {
            newState.profiled.data = action.profiledList;
          }
        } else {
          const filteredContacts = action.profiledList.filter(
            (contact) =>
              !newState.contactsAddedToList.some(
                (listContact: { [key: string]: any }) => contact.id === listContact.id,
              ),
          );
          newState.profiled.data = [...state.profiled.data, ...filteredContacts];
        }
        newState.profiled.page = state.profiled.page + 1;
        if (newState.profiled.page > 1 && action.profiledList?.length === 0) {
          newState.profiled.paginationStatus = false;
        }
        if (action?.profiledList?.length < 4) {
          newState.profiled.paginationStatus = false;
        }
      } else {
        if (newState.totalContacts > 0) {
          let newData = state.profiled.data.filter(
            (x) => x.color !== '' && x.color !== null && x.personality !== '' && x.personality !== 'N/A',
          );
          newState.profiled.data = newData;
        } else {
          newState.profiled.data = [];
        }
      }
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS.ERROR_SEARCH_TERM:
      newState.success = action.success;
      newState.message = action.message;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS.ERROR_SEARCH_TERM_LOADING:
      newState.profiled.loading = false;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS.FAIL:
      newState.profiled.loading = false;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS.RESET:
      newState.profiled.data = Array<Interfaces.IContactItem>();
      newState.profiled.page = 0;
      return newState; //Filters

    case AUDIENCE_LISTS_PROFILED_CONTACTS.SET_FILTERS:
      newState.filters = action.filters;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS.SET_SELECTED_FILTERS:
      newState.selectedFilters = action.selectedFilters;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS.REMOVE_NON_PROFILED:
      newState.profiled.data = newState.profiled.data?.filter((item) => !item.personality);
      newState.removeUnprofiledFromProfiled = false;
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS.LOAD:
      newState.nonProfiled.loading = true;
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS.SUCCESS:
      newState.nonProfiled.loading = false;
      newState.totalContacts = action.totalContacts;
      if (newState.totalContacts > 0) newState.exportLoading = false;
      else newState.exportLoading = true;
      if (action.nonProfiledList && action.nonProfiledList?.length > 0) {
        if (action?.reset) {
          newState.nonProfiled.data = action.nonProfiledList;
        } else {
          newState.nonProfiled.data = [...state.nonProfiled.data, ...action.nonProfiledList];
        }
        newState.nonProfiled.page = state.nonProfiled.page + 1;
      } else {
        if (newState.totalContacts > 0) {
          let newData = state.nonProfiled?.data.filter(
            (x) => (x.color === '' || x.color === null) && x.personality === 'N/A',
          );
          newState.nonProfiled.data = newData;
        } else {
          newState.nonProfiled.data = [];
        }
      }

      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS.FAIL:
      newState.nonProfiled.loading = false;
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS.RESET:
      newState.nonProfiled.data = Array<Interfaces.IContactItem>();
      newState.nonProfiled.page = 0;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE.LOAD:
      newState.delete.loading = true;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE.UNSUBSCRIBE_LIST_SUCCESS:
      if (action.toBeDeleted) {
        let newArray = [...state.profiled.data].filter((item) => !action.toBeDeleted?.includes(item.id));
        newState.profiled.data = [...newArray];
      }
      newState.delete.loading = false;
      newState.delete.success = true;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE.SUCCESS:
      if (action.toBeDeleted) {
        let newArray = [...state.profiled.data].filter((item) => !action.toBeDeleted?.includes(item.id));
        newState.profiled.data = [...newArray];
        newState.totalContacts = newState.totalContacts - action.toBeDeleted?.length;
        if (newState.contactsAddedToList.length > 0) {
          newState.contactsAddedToList = newState.contactsAddedToList.filter(
            (item) => !action.toBeDeleted?.includes(item.id),
          );
        }
      }
      newState.delete.loading = false;
      newState.delete.success = true;
      if (newState.totalContacts > 0) newState.exportLoading = false;
      else newState.exportLoading = true;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE.FAIL:
      newState.delete.loading = false;
      newState.delete.fail = true;
      return newState;

    case AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE.RESET:
      newState.delete = { loading: false, success: false, fail: false };
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE.LOAD:
      newState.delete.loading = true;
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE.UNSUBSCRIBE_LIST_SUCCESS:
      if (action.toBeDeleted) {
        let newArray = [...state.nonProfiled.data].filter((item) => !action.toBeDeleted?.includes(item.id));
        newState.nonProfiled.data = [...newArray];
      }
      newState.delete.loading = false;
      newState.delete.success = true;
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE.SUCCESS:
      if (action.toBeDeleted) {
        let newArray = [...state.nonProfiled.data].filter((item) => !action.toBeDeleted?.includes(item.id));
        newState.nonProfiled.data = [...newArray];
        newState.totalContacts = newState.totalContacts - action.toBeDeleted?.length;
      }
      newState.delete.loading = false;
      newState.delete.success = true;
      if (newState.totalContacts > 0) newState.exportLoading = false;
      else newState.exportLoading = true;
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE.FAIL:
      newState.delete.loading = false;
      newState.delete.fail = true;
      return newState;

    case AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE.RESET:
      newState.delete = { loading: false, success: false, fail: false };
      return newState;

    case AUDIENCE_LISTS_DETAILS.TOTAL_COUNT_UPDATE_ON_DELETE_ALL_LIST:
      newState.totalContacts = action.unselectedIds;
      return newState;

    case AUDIENCE_LISTS_DETAILS.TOTAL_COUNT_UPDATE_LIST:
      if (action.deleteCount) newState.totalContacts = newState.totalContacts - action.deleteCount;
      return newState;

    case AUDIENCE_LISTS_DETAILS.RESET_TOTAL_COUNT:
      newState.totalContacts = 0;
      return newState;

    case AUDIENCE_LISTS_CONTACTS_EDIT.SUCCESS:
      if (action.updateContact) {
        const { contact_id, contact_name, designation, organization, contact_email, company_website } =
          action.updateContact;

        newState.profiled.data.map((contact: any) => {
          if (contact.id === contact_id) {
            contact.email = contact_email;
            contact.name = contact_name;
            contact.designation = designation;
            contact.organization = organization;
          }
        });
        newState.nonProfiled.data.map((contact: any) => {
          if (contact.id === contact_id) {
            contact.email = contact_email;
            contact.name = contact_name;
            contact.designation = designation;
            contact.organization = organization;
          }
        });
      }
      return newState;

    case AUDIENCE_LISTS_DETAILS.SET_SEARCH_TERM:
      newState.searchTermListDetails = action.searchTermListDetails;
      return newState;

    case AUDIENCE_LISTS_ADD.NEWLY_CREATED_LIST_ID:
      newState.newlyCreatedListId = action.newlyCreatedListId;
      return newState;

    case AUDIENCE_LISTS_BOTH.ADD_TO_EXISTING_LIST:
      newState.contactsAddedToList = action.contactsToAdd;
      newState.profiled.data = [...action.contactsToAdd, ...newState.profiled.data];
      newState.totalContacts = action.contactsAddCount;
      return newState;

    case AUDIENCE_LISTS_BOTH.REMOVE_FROM_EXISTING_LIST:
      newState.profiled.data = action.remainingProfilesInList;
      return newState;

    case AUDIENCE_LISTS_DETAILS.CONTACTS_ADDED_TO_LIST:
      newState.contactsAddedToList = action.contactsAddedToList;
      return newState;

    case AUDIENCE_LISTS_DETAILS.RESET_CONTACTS_ADDED_TO_LIST:
      newState.contactsAddedToList = [];
      return newState;

    case AUDIENCE_LISTS_DETAILS.SET_APPLIED_SEARCH:
      newState.appliedSearch = action.appliedSearch;
      return newState;

    case AUDIENCE_LISTS_DETAILS.SET_CLEAR_SEARCH_TERM:
      newState.clearSearchTerm = action.clearSearchTerm;
      return newState;

    default:
      return newState;
  }
};
